var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-notfound"},[_c('div',{staticClass:"container text-center"},[_c('img',{attrs:{"src":require("../assets/images/not-found.svg"),"height":"200"}}),_c('h6',[_vm._v("Data tidak ditemukan")])])])
}]

export { render, staticRenderFns }